module.exports = __webpack_public_path__ + "static/img/game-logo@2x.906eec21.png";